// MythSection.tsx
import React from "react";
import { Box, Paper, Divider, Typography } from "@mui/material";
import Quiz, { QuestionProps } from "./Quiz";

type MythSectionProps = {
  questions: QuestionProps[];
  media?: React.ReactNode;
  reversed?: boolean;
  mythTitles?: string;
  youtubeUrl?: string; // 🔹 Neu: YouTube-Embed-URL
};

const MythSection: React.FC<MythSectionProps> = ({
  questions,
  media,
  reversed,
  mythTitles,
  youtubeUrl,
}) => {
  return (
    <Paper
      elevation={4}
      sx={{
        width: "80%",
        height: "95%",
        borderRadius: 4,
        overflow: "hidden",
        position: "relative",
        boxSizing: "border-box",
        p: { xs: 3, md: 6 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#ffffff",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: {
            xs: "column",
            md: reversed ? "row-reverse" : "row",
          },
          alignItems: "stretch",
        }}
      >
        {/* Quiz-Seite */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <Typography variant="h5" sx={{ mb: 1, fontSize: "40px" }}>
            {mythTitles}
          </Typography>

          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <Quiz questions={questions} />
          </Box>
        </Box>

        <Divider
          orientation="vertical"
          flexItem
          sx={{
            display: { xs: "none", md: "block" },
            mx: 4,
            alignSelf: "stretch",
            borderColor: "#e0e0e0",
          }}
        />

        {/* Media / YouTube-Video-Seite */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            mt: { xs: 4, md: 0 },
          }}
        >
          {youtubeUrl ? (
            <Box
              sx={{
                width: "100%",
                maxWidth: 700,
                aspectRatio: "16 / 9",
                position: "relative",
              }}
            >
              <Box
                component="iframe"
                src={youtubeUrl}
                title={mythTitles || "Myth video"}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                sx={{
                  border: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: 3,
                  boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
                  display: "block",
                }}
              />
            </Box>
          ) : (
            media || <span style={{ opacity: 0.4 }}>Media Placeholder</span>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default MythSection;
